import { TQueryTransaction } from '@src/modules/transaction'

import { request } from './config'

export const getLisTransaction = (params: TQueryTransaction, token: string) =>
  request({ url: 'transaction', method: 'GET', params }, { token })
